// Format canonical 7XXXXXXXXXX → +7 (XXX) XXX-XX-XX for display.
//
// Жил внутри CallModal; вынесен, чтобы им пользовались и чистые модули (они
// тестируются в node, и тянуть ради одной функции компонент с CSS незачем).
export function fmtPhone(p: string): string {
  const d = p.replace(/\D/g, "");
  if (d.length === 11 && (d[0] === "7" || d[0] === "8")) {
    return `+7 (${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7, 9)}-${d.slice(9)}`;
  }
  return p;
}
